$(function () {

  $('.js-show-password-button').on('click', e => {
    e.preventDefault()
    const $target = $(e.currentTarget)
    const $container = $target.parents('.js-input')
    const $field = $container.find('input') 
    $field.attr( 'type', 'text' )
    $container.addClass('show-password')
  })

  $('.js-hide-password-button').on('click', e => {
    e.preventDefault()
    const $target = $(e.currentTarget)
    const $container = $target.parents('.js-input')
    const $field = $container.find('input') 
    $field.attr( 'type', 'password' )
    $container.removeClass('show-password')
  })

})